import api from './api'

type UpdateChargePointsModel = {
    firmwareId: number
    chargePointIds: string[]
}

const updateChargePointsFirmware = (model: UpdateChargePointsModel): Promise<unknown> =>
    api<unknown>({ method: 'POST', path: '/chargepoints/firmware/update', body: model })

export default updateChargePointsFirmware
